import { render, staticRenderFns } from "./PayCreateAccountOut.vue?vue&type=template&id=52a05dfc"
import script from "./PayCreateAccountOut.vue?vue&type=script&lang=js"
export * from "./PayCreateAccountOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports